import React from "react";
// import Lightbox from "./components/Lightbox";
import DesignThumb01 from "./img/iep-ui-design01-thumb.png";
import Design01 from "./img/iep-ui-design01.png";
import DesignThumb02 from "./img/iep-ui-design02-thumb.png";
import Design02 from "./img/iep-ui-design02.png";
import DesignThumb03 from "./img/iep-ui-design04-thumb.png";
import Design03 from "./img/iep-ui-design04.png";
import DesignThumb04 from "./img/iep-ui-design06-thumb.png";
import Design04 from "./img/iep-ui-design06.png";
import DesignThumb05 from "./img/iep-ui-design07-thumb.png";
import Design05 from "./img/iep-ui-design07.png";
import IconFaClose from "../img/IconFaClose";

function IEPCardDesignsThumbs() {
	function handleLightbox(e) {
		// get set large image
		const largeImg = e.target.dataset.large;
		const lightboxImg = document.getElementById("lightboxImage");
		lightboxImg.src = largeImg;
		// add active class to lightbox
		const lbScreen = document.getElementById("lightboxScreen");
		const lbContent = document.getElementById("lightboxContent");
		lbScreen.classList.add("active");
		lbContent.classList.add("active");
		// add scroll lock to <body>
		const bodyScroll = document.getElementById("body");
		// bodyScroll.className.add("lightboxScroll"); errors: there may be a problem adding classes to index.html - JSX to html ?
		bodyScroll.setAttribute("style", "overflow:hidden;");

		console.log(bodyScroll, largeImg, lbScreen, lbContent);
	}

	function handleCloseLightbox(e) {
		// get and remove active classes
		const lbScreen = document.getElementById("lightboxScreen");
		const lbContent = document.getElementById("lightboxContent");
		lbScreen.classList.remove("active");
		lbContent.classList.remove("active");
		// get and remove large image
		const lightboxImg = document.getElementById("lightboxImage");
		lightboxImg.src = "";
		// remove scroll lock on <body>
		const bodyScroll = document.getElementById("body");
		bodyScroll.removeAttribute("style");
	}

	return (
		<>
			<ul className="thumbs-list" id="gallery">
				<li>
					<figure className="wire">
						<img
							onClick={handleLightbox}
							src={DesignThumb01}
							alt="Wireframe for Eligibility application"
							data-large={Design01}
						/>
					</figure>
					<figcaption className="caption">UI option for search</figcaption>
				</li>
				<li>
					<figure className="wire">
						<img
							onClick={handleLightbox}
							src={DesignThumb02}
							alt="UI option for search and results"
							data-large={Design02}
						/>
					</figure>
					<figcaption className="caption">
						UI option for search and results
					</figcaption>
				</li>
				<li>
					<figure className="wire">
						<img
							onClick={handleLightbox}
							src={DesignThumb03}
							alt="Detail of a loading component"
							data-large={Design03}
						/>
					</figure>
					<figcaption className="caption">
						Detail of a loading component
					</figcaption>
				</li>
				<li>
					<figure className="wire">
						<img
							onClick={handleLightbox}
							src={DesignThumb04}
							alt="Floating labels for forms design"
							data-large={Design04}
						/>
					</figure>
					<figcaption className="caption">
						Floating labels for forms design
					</figcaption>
				</li>
				<li>
					<figure className="wire">
						<img
							onClick={handleLightbox}
							src={DesignThumb05}
							alt="Interface structure and grid layout"
							data-large={Design05}
						/>
					</figure>
					<figcaption className="caption">
						Interface structure and grid layout
					</figcaption>
				</li>
			</ul>
			<div
				className="lightbox-screen"
				id="lightboxScreen"
				onClick={handleCloseLightbox}
			></div>
			<div className="lightbox-content" id="lightboxContent">
				<figure>
					<img className="lightbox-image" id="lightboxImage" src="" alt="" />
					<figcaption id="lightboxCaption"></figcaption>
				</figure>
				<button className="btn-close" onClick={handleCloseLightbox}>
					<IconFaClose />
					close
				</button>
			</div>
		</>
	);
}

export default IEPCardDesignsThumbs;
